/* @flow */
import * as React from 'react';
import ScrollWatch from 'components/ScrollWatch';
import type { SequenceItem } from '../chunker';

type Props = {
  items: Array<SequenceItem>,
  scrolledIntoView: (items: Array<SequenceItem>) => void,
};

class GapItems extends React.Component<Props> {
  handleScrolledIntoView = () => {
    this.props.scrolledIntoView(this.props.items);
  };

  render() {
    return (
      <ScrollWatch onEnter={this.handleScrolledIntoView} threshold={0.2}>
        <div />
      </ScrollWatch>
    );
  }
}

export default GapItems;
